import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { ChargePointHasSubscription } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-subscription.enum';
import { useTranslation } from 'react-i18next';

export interface ChargePointHasSubscriptionFilterStateControllerProps {
  value: boolean;
  onRemove: FilteredItemProps['onRemove'];
}

export const ChargePointHasSubscriptionFilterStateController = ({
  value,
  onRemove,
}: ChargePointHasSubscriptionFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const chargePointHasSubscription = value
    ? ChargePointHasSubscription.TRUE
    : ChargePointHasSubscription.FALSE;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="receipt-check"
      label={t(
        `delmonicos-shared-sdk.outputs-charge-point-has-subscription.${chargePointHasSubscription}`,
      )}
      onRemove={onRemove}
    />
  );
};
